import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { AppLoadService } from '@ebb-v2/ebb-integration';

import {
  AuthenticationService,
  ApplicationApiService
} from '../../data-services/index';

import {
  IApplication, IApplicationInput, IUser,
  IOptionSets, IOptions, IApprovalTask
} from '@ebb-v2/ebb-integration';

@Component({
    selector: 'ebb-portal-receipt-form',
    templateUrl: './receipt-form.component.html',
    standalone: false
})
export class ReceiptFormComponent implements OnInit {
  @Input('application') application: IApplication;
  @Input('listOptionSets') listOptionSets: IOptionSets[];
  @Input('task') task: IApprovalTask;
  @Output() emitReceiptFormChangeEvent = new EventEmitter<IApplicationInput>();

  public currentUser: IUser;

  public formReceipts: FormGroup;
  public formAutoSaveInspection = false;
  public receiptEngineeredTypeOptions: IOptions[] = {} as IOptions[];
  public receiptRetrofitTypeOptions: IOptions[] = {} as IOptions[];
  public filteredRetrofitTypeOptions: IOptions[] = [] as IOptions[];
  public autoSaveIndicator = false;
  public disableSaveButton: boolean;
  public retrofitTypeLabel: string;


  constructor(
    private readonly fb: FormBuilder,
    private readonly authenticationService: AuthenticationService,
    private readonly apiApplication: ApplicationApiService,
    private readonly appLoadService: AppLoadService,
  ) {}

  ngOnInit() {
    this.currentUser = this.authenticationService.currentUserValue;
    this.disableSaveButton = true;
    this.initializeForms();

    const indexRetrofitOptions = this.listOptionSets.findIndex(
      i => i.name === 'cea_retrofittype'
    );
    this.receiptRetrofitTypeOptions = [
      ...this.listOptionSets[indexRetrofitOptions].options
    ];
    const indexEngineeredOptions = this.listOptionSets.findIndex(
      i => i.name === 'cea_isengineeredsolution'
    );
    this.receiptEngineeredTypeOptions = [
      ...this.listOptionSets[indexEngineeredOptions].options
    ];
if(this.application.programType === 700000004){
  let filteredOptions = [];

  this.receiptEngineeredTypeOptions.forEach(x => {
    if (x.value == 700000000) {
      filteredOptions.push(x);
    } 
  });
  this.receiptEngineeredTypeOptions = filteredOptions;
}
    if(this.application.programType === 700000003)  {
      this.filteredRetrofitTypeOptions.push(this.receiptRetrofitTypeOptions[2]);
      this.filteredRetrofitTypeOptions.push(this.receiptRetrofitTypeOptions[3]);
      this.filteredRetrofitTypeOptions.push(this.receiptRetrofitTypeOptions[4]);
      this.retrofitTypeLabel = 'What is your Retrofit type?';
    } else if(this.application.programType === 700000004)  {
      this.filteredRetrofitTypeOptions.push(this.receiptRetrofitTypeOptions[5]);
      this.retrofitTypeLabel = 'What is your Retrofit type?';
    }
    else {
      this.filteredRetrofitTypeOptions.push(this.receiptRetrofitTypeOptions[0]);
      this.filteredRetrofitTypeOptions.push(this.receiptRetrofitTypeOptions[1]);
      this.retrofitTypeLabel = 'Is your Retrofit Cripple Wall and Bolt or Bolt only?';
    }

    this.loadReceiptsInfoForm();
  }

  private initializeForms(): void {
    this.formReceipts = this.fb.group({
      retrofittype: ['', Validators.required],
      engineeredtype: ['', Validators.required],
      permitCost: ['', Validators.min(0.00)],
      materialCost: ['', Validators.min(0)],
      laborCost: ['', Validators.min(0)],
      overheadProfitCost: ['', Validators.min(0)],
      engineerFeeCost: ['', Validators.min(0)],
      totalamount:['',{readonly:true}]
    });
  }

  private loadReceiptsInfoForm(): void {
    if (this.application.retrofitType && this.application.retrofitType >= 700000000) {
      this.formReceipts
        .get('retrofittype')
        .patchValue(this.application.retrofitType);
    }

    if (this.application.engineeredSolutionType && this.application.engineeredSolutionType >= 700000000) {
      this.formReceipts
        .get('engineeredtype')
        .patchValue(this.application.engineeredSolutionType);
    }

    if (this.application.permitCost && this.application.permitCost >= 0) {
      this.formReceipts.get('permitCost').setValue(this.application.permitCost);
    } else{
      this.formReceipts.get('permitCost').setValue(0);
    }

    if (this.application.materialCost && this.application.materialCost >= 0) {
      this.formReceipts
        .get('materialCost')
        .setValue(this.application.materialCost);
    } else {
      this.formReceipts.get('materialCost').setValue(0);
    }

    if (this.application.laborCost && this.application.laborCost >= 0) {
      this.formReceipts
        .get('laborCost')
        .setValue(this.application.laborCost);
    } else {
      this.formReceipts.get('laborCost').setValue(0);
    }

    if (this.application.overheadProfitCost && this.application.overheadProfitCost >= 0) {
      this.formReceipts
        .get('overheadProfitCost')
        .setValue(this.application.overheadProfitCost);
    } else {
      this.formReceipts.get('overheadProfitCost').setValue(0);
    }
 if (this.application.engineerFeeCost && this.application.engineerFeeCost >= 0) {
      this.formReceipts
        .get('engineerFeeCost')
        .setValue(this.application.engineerFeeCost);
    } else {
      this.formReceipts.get('engineerFeeCost').setValue(0);
    }
    if(this.application.sGStatus === 700000004 && (this.application.sGPermitPaidDate != null || this.application.sGBuildingPermitProcessing != null) ) {
      this.formReceipts.get('permitCost').disable();
    }
    if(this.application.programType === 700000004  ) {
      this.formReceipts.get('permitCost').disable();
    }

    if (this.application.eventApplicationSubmitted === true && !(parseInt(this.application.submissionRejection?.toString(), 10) === 700000001 && this.task.stateCode !== 700000001)) {
      if ((this.application.stageCode === 700000001 && this.application.eventApplicationSubmitted === true) ||
          (this.isContractor() && this.application.contractorPermissionsCode === 700000003) ||
          this.application.eventMitigationReviewSubmitted || this.application.eventFinancialReviewSubmitted
        ) {
        this.formReceipts.get('retrofittype').disable();
        this.formReceipts.get('engineeredtype').disable();
        this.formReceipts.get('permitCost').disable();
        this.formReceipts.get('materialCost').disable();
        this.formReceipts.get('laborCost').disable();
        this.formReceipts.get('overheadProfitCost').disable();
        this.formReceipts.get('engineerFeeCost').disable();
      }
    }
    this.totalAmount();
  }

  public onCheckReceiptControlValidators(controlName: string): boolean {
    const retVal =
      this.formReceipts.get(controlName).errors &&
      (this.formReceipts.get(controlName).dirty ||
        this.formReceipts.get(controlName).touched);
    return retVal;
  }

  public setCostToZeroIfEmpty(event) {
    if (event.target.value === '' || event.target.value <= 0 || event.target.value < .01) {
      event.target.value = 0;
      this.disableSaveButton = true;
      this.totalAmount();

    } else {
      if (this.formReceipts.pristine || this.formReceipts.invalid) {
        this.disableSaveButton = true;
      } else {
        this.disableSaveButton = false;
      }
    }
  }

  public totalAmount() {
    let totalCost, permitCost, materialCost, laborCost, overheadProfitCost = 0;
    let retVal = null;
    (!isNaN(Number.parseFloat(this.formReceipts.get('permitCost').value)))
      ? permitCost = Number.parseFloat(this.formReceipts.get('permitCost').value)
      : permitCost = 0;
    (!isNaN(Number.parseFloat(this.formReceipts.get('materialCost').value)))
      ? materialCost = Number.parseFloat(this.formReceipts.get('materialCost').value)
      : materialCost = 0;
    (!isNaN(Number.parseFloat(this.formReceipts.get('laborCost').value)))
      ? laborCost = Number.parseFloat(this.formReceipts.get('laborCost').value)
      : laborCost = 0;
    (!isNaN(Number.parseFloat(this.formReceipts.get('overheadProfitCost').value)))
      ? overheadProfitCost = Number.parseFloat(this.formReceipts.get('overheadProfitCost').value)
      : overheadProfitCost = 0;

    totalCost = permitCost + materialCost + laborCost + overheadProfitCost;
if(this.application.programType === 700000002 || this.application.programType === 700000003) {

      if (!isNaN(Number.parseFloat(this.formReceipts.get('engineerFeeCost').value))) {
        totalCost += Number.parseFloat(this.formReceipts.get('engineerFeeCost').value);
      } else {
        totalCost += 0;
      }
    
}
    if (!isNaN(totalCost)) {
      retVal = totalCost.toFixed(2);
    }


    return retVal;
  }

  public onClickSaveReceiptsInfo(): void {
    const applicationInput: IApplicationInput = {} as IApplicationInput;
    applicationInput.retrofitType = parseInt(this.formReceipts.get('retrofittype').value, 10);
    applicationInput.engineeredSolutionType = parseInt(this.formReceipts.get('engineeredtype').value, 10);
    if (this.formReceipts.get('laborCost').value > 0) {
      applicationInput.laborCost = this.formReceipts.get('laborCost').value;
    }else{
      applicationInput.laborCost = 0;
    }
    if (this.formReceipts.get('materialCost').value > 0){
          applicationInput.materialCost = this.formReceipts.get('materialCost').value;
    } else{
      applicationInput.materialCost = 0;
    }
    const permitcost = this.formReceipts.get('permitCost').value;
    if (permitcost > 0) {
      if (permitcost !== this.application.permitCost) {
        applicationInput.permitCost = permitcost;
      }
    } else {
      applicationInput.permitCost = 0;
    }
    if (this.formReceipts.get('overheadProfitCost').value > 0) {
      applicationInput.overheadProfitCost = this.formReceipts.get('overheadProfitCost').value;
    }else{
      applicationInput.overheadProfitCost = 0;
    }
if(this.application.programType === 700000002 || this.application.programType === 700000003) {

  if (this.formReceipts.get('engineerFeeCost').value > 0) {
      applicationInput.engineerFeeCost = this.formReceipts.get('engineerFeeCost').value;
    }else{
      applicationInput.engineerFeeCost = 0;
    }
}
    this.autoSaveIndicator = true;

    this.apiApplication
      .updateApplication(applicationInput, this.application.id)
      .subscribe(
        () => {
          this.emitReceiptFormChangeEvent.emit(applicationInput);

          this.formReceipts.markAsPristine();
          this.disableSaveButton = true;
          this.autoSaveIndicator = false;
        },
        error => console.warn(`ERROR: onClickSavePermitInfo() - ${error}`)
      );
  }

  /***     User Convenience Methods */
  public isHomeowner() : boolean {
    return this.authenticationService.isHomeowner(this.currentUser);
  }

  public isContractor(): boolean {
    return this.authenticationService.isContractor(this.currentUser);
  }
}
